<template>
  <div class="min-h-screen flex flex-col bg-background">
    <Header />
    <main class="flex-1 min-h-screen pt-20">
      <slot />
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Header from '#components/base/Header.vue';
import Footer from '#components/base/Footer.vue';
</script>

<style>
body {
  margin: 0;
  font-family: 'DM Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
